import * as Sentry from '@sentry/vue'
import { msalInstance } from '../auth/msalConfig'

// Not a secret: the browser sees it anyway. Local dev reports too, as environment "local".
const dsn = 'https://e5df003e229b9da6b078de36aea97459@o970088.ingest.us.sentry.io/4512344610897920'

// Errors only (no tracing or replay). The signed-in user (name and e-mail, as in the header)
// is read when an error is sent rather than tracked on every login.
export function initSentry (app) {
  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || (import.meta.env.DEV ? 'local' : 'develop'),
    sendDefaultPii: false,
    beforeSend (event) {
      const account = msalInstance.getActiveAccount()
      if (account) {
        event.user = {
          username: account.name || account.username,
          email: account.idTokenClaims?.email || account.idTokenClaims?.emails?.[0] || account.username,
        }
      }
      return event
    },
  })
}
